var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("Chi_DefaultSection", {
    staticClass: "menu--section-chi_chinese_new_year",
    attrs: {
      menu: _vm.menu,
      section: _vm.section,
      "section-modifier": _vm.sectionModifier,
      "menu-item-component": "chi-chinese-new-year-item",
      "menu-item-tag-location": "after_title",
      "item-group-layout": "single_column",
      "content-area-top-layout": "full_width",
      "content-area-bottom-layout": "full_width",
      "is-title-box-visible": false,
      "is-title-buffer-visible": true,
      "section-menu-type": "chi-chinese-new-year-item",
    },
    scopedSlots: _vm._u([
      {
        key: "sectionTitleImage",
        fn: function () {
          return [
            _c("img", {
              staticClass: "menu--section_title_image",
              attrs: {
                src: "/library/images/menu/chinese-new-year-chi-logo.jpg",
                alt: "Chinese New Year Menu",
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "beforeBottomContentArea",
        fn: function () {
          return [
            _c("img", {
              staticClass: "menu--section_title_image",
              attrs: {
                src: "/library/images/menu/chinese-new-year-chi-seal.jpg",
                alt: "Chinese New Year Menu",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }